import * as _ from 'underscore';
import * as angular from 'angular';
import { StateParams } from '@uirouter/core';
import { InformationCardsService } from '../../informationCards.service';
import { IRetailerRootScope } from '../../../core/models';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { PopupServiceCancel } from '../../../../../app.common/modules/common/models/popupServiceCancel';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { ViewportController } from '../../../../../app.common/modules/common/controllers/viewport-typed.controller';
import {
    InformationCardListItem, InformationCardsPagingResult, InformationCardFilter
} from '../../../core';
import {
    IColumnProductSortSet, ILinkListItem,
    IInformationCardLinkListItem
} from '../../models';
import { EnumService } from '../../../../../app.common/modules/common/services/enum.service';

interface IProductStateParams {
    page: number | string;
    sort: IColumnProductSortSet;
    order: string;
    state: number | string;
    search: string | string;
    column: string;
}
class InformationCardsController extends ViewportController {

    static $inject = ['$rootScope', '$scope', '$stateParams', '$q', '$timeout',
        'informationCardsService', 'popupService', 'notificationService', 'enumService', '$translate'];

    waiting = false;
    data: InformationCardsPagingResult = {
        Items: [],
        Total: 0
    };
    settings = {
        pageSize: 5,
        page: 1,
        sortSet: this.informationCardsService.getSortSet(),
        sort: <IColumnProductSortSet>null,
        productFilter: '',
        productState: <number>null,
        isExistActiveProducts: null,
        isExistArchiveProducts: null,
        getFilter: (): InformationCardFilter => {
            let i = this.settings;
            var search = i.productFilter ? i.productFilter.trim() : '';
            return {
                Limit: i.pageSize,
                Offset: (i.page - 1) * i.pageSize,
                SortColumn: i.sort.column,
                SortOrder: i.getSortOrder(i.sort.order),
                CardName: search,
                CardID: '',
                State: <InformationCardFilter.StateEnum>i.productState
            };
        },
        getSortOrder: (sortOrder: string): InformationCardFilter.SortOrderEnum => {
            return sortOrder === 'ascending' ? InformationCardFilter.SortOrderEnum.NUMBER_0 : InformationCardFilter.SortOrderEnum.NUMBER_1;
        },
        getStateParams: (): IProductStateParams => {
            let i = this.settings;
            var search = i.productFilter ? i.productFilter.trim() : '';
            return {
                page: encodeURIComponent(i.page.toString()),
                column: encodeURIComponent(i.sort.column),
                order: encodeURIComponent(i.sort.order),
                state: encodeURIComponent(i.productState.toString()),
                search: encodeURIComponent(search),
                sort: null
            };
        },
        settingsClear: (state: number) => {
            let i = this.settings;
            i.page = 1;
            i.sort = this.informationCardsService.getSort();
            i.productFilter = '';
            i.productState = _.isUndefined(state) ? this.productState.Active : state;
        },
        isShowFilter: () => {
            let i = this.settings;
            return (this.productState.Archived === i.productState && i.isExistArchiveProducts === true) ||
                (this.productState.Active === i.productState && i.isExistActiveProducts === true);
        }
    };

    private linkTypes: ILinkListItem[] = [];
    private productState = this.$rootScope.enums.PhysicalProductState;
    private params: IProductStateParams = null;

    constructor(
        private $rootScope: IRetailerRootScope,
        private $scope: ng.IScope,
        private $stateParams: StateParams,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private informationCardsService: InformationCardsService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private enums: EnumService,
        private $translate: angular.translate.ITranslateService
    ) {
        super($rootScope);
        this.params = <IProductStateParams>{
            page: parseInt($stateParams.page, 10),
            search: decodeURIComponent($stateParams.search),
            sort: informationCardsService.getSort(decodeURIComponent($stateParams.column), decodeURIComponent($stateParams.order)),
            state: parseInt(decodeURIComponent($stateParams.state), 10)
        };
        this.params.page = this.params.page ? this.params.page : 1;
        this.params.sort = this.params.sort ? this.params.sort : this.informationCardsService.getSort();
        this.params.state = this.params.state ? this.params.state : this.productState.Active;

        this.settings.page = <number>this.params.page;
        this.settings.sort = this.params.sort;
        this.settings.productFilter = this.params.search;
        this.settings.productState = <number>this.params.state;

        $scope.$watchGroup(['vm.settings.productState', 'vm.settings.page'],
            (n: any, o: any) => {
                if (n !== o) {
                    this.reload();
                }
            });

        this.getData();
    }

    applyFilter = () => {
        this.settings.page = 1;
        this.reload();
    }

    getImageUrl = (imageIDs: string[] | string, width: number, height: number) => {
        if (!imageIDs) {
            return null;
        }
        if (_.isArray(imageIDs)) {
            return this.informationCardsService.getImageUrl(_.first(imageIDs), width, height);
        } else {
            return this.informationCardsService.getImageUrl(imageIDs, width, height);
        }
    }

    archive = async (product: InformationCardListItem) => {
        try {
            let popupTitle = this.$translate.instant('archive_information_card');
            let popupContent = this.$translate.instant('archive_information_card_confirm');

            await this.popupService.confirm({
                title: popupTitle,
                content: popupContent,
                okTxt: this.$translate.instant('no'),
                cancelTxt: this.$translate.instant('yes'),
                cancelClass: 'btn-success',
                invertAction: true
            });
            this.archiveProductInternal(product);
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    restore = async (product: InformationCardListItem) => {
        try {
            let popupTitle = this.$translate.instant('restore_information_card');
            let popupContent = this.$translate.instant('restore_information_card_confirm');

            await this.popupService.confirm({
                title: popupTitle,
                content: popupContent,
                okTxt: this.$translate.instant('no'),
                cancelTxt: this.$translate.instant('yes'),
                cancelClass: 'btn-success',
                invertAction: true
            });
            this.restoreProductInternal(product);
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    onSearchFilterKeyPress($event: any) {
        if ($event.which === 13) {
            return this.applyFilter();
        }

        return 0;
    }

    private adaptData() {
        _.forEach(<InformationCardListItem[]>this.data.Items, (product) => {
            _.forEach(<IInformationCardLinkListItem[]>product.Links, (link) => {
                link.viewClass = _.findWhere(this.linkTypes, { ID: link.Type }).viewClass;
            });
        });
        this.$timeout(function () {
            $('.wrapUlTags.overflowY').slimScroll({
                height: 'auto'
            });

            ($('.wysiwyg__main') as any).mCustomScrollbar({
                axis: 'y',
                theme: 'minimal-dark'
            });
        });
    }

    private reload() {
        this.$rootScope.$state.go('app.information-cards', this.settings.getStateParams());
    }

    private getData = async () => {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {

            let response = await this.$q.all([
                this.informationCardsService.getInformationCards(this.settings.getFilter()),
               <angular.IPromise<ILinkListItem[]>> this.informationCardsService.getLinkTypes(),
                this.informationCardsService.isExistInformationCards(this.productState.Active),
                this.informationCardsService.isExistInformationCards(this.productState.Archived)
            ]);
            this.notificationService.clearAll();
            this.data = response[0];
            this.linkTypes = response[1];
            this.settings.isExistActiveProducts = response[2];
            this.settings.isExistArchiveProducts = response[3];
            this.adaptData();
            if (this.data.Total === 0 && !_.isEmpty(this.settings.productFilter)) {
                this.notificationService.showInfoMessage(null);
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private archiveProductInternal = async (product: InformationCardListItem) => {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            let id = await this.informationCardsService.archiveInformationCard(product.ID);

            this.settings.settingsClear(this.productState.Archived);

            if (this.settings.productState !== this.productState.Archived) {
                this.settings.settingsClear(this.productState.Archived);
            } else {
                this.getData();
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private restoreProductInternal = async (product: InformationCardListItem) => {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            let id = await this.informationCardsService.restoreInformationCard(product.ID);

            this.settings.settingsClear(this.productState.Archived);

            if (this.settings.productState !== this.productState.Archived) {
                this.settings.settingsClear(this.productState.Archived);
            } else {
                this.getData();
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }
}

angular
    .module('naut').component('informationCards', {
        template: require('./informationCards.html'),
        controller: InformationCardsController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/informationCards/components/informationCards/informationCards.component.ts